import { FunctionComponent, useContext } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

import { Routes } from 'types/routes';

import FeatureList from 'models/FeatureList';
import Plan from 'models/Plan';

import ProfileContext from 'components/context/Profile';
import Button from 'components/layout/Button';
import { ButtonStyles, ButtonVariants } from 'components/layout/Button/types';
import { Sizes } from 'components/layout/LayoutContainer';
import LayoutContainer from 'components/layout/LayoutContainer/component';

import StyledComponent from './styles';
import { Props } from './types';

const SectionPlans: FunctionComponent<Props> = ({ translations, plans }) => {
    const router = useRouter();
    const profileCtx = useContext(ProfileContext);
    const isLogged = profileCtx?.profile;

    const filteredElements: Plan[] = plans?.elements
        .filter(element => element?.planFeatures?.length > 0)
        .sort((a, b) => a.priceMonth - b.priceMonth);
    const convertToFeatureList = filteredElements?.map((plan) => new FeatureList(plan));

    const tempStyleDependency = {
        trainer: 'Trener',
        highPriest: 'Arcykapłan',
        sage: 'Mędrzec',
    };

    return (
        <StyledComponent className="section-plans">
            <LayoutContainer size={Sizes.Medium}>
                <div className="plan-list">
                    {convertToFeatureList?.map((plan) => (
                        <div
                            className="plan-list__item"
                            key={plan?.id}
                        >
                            <div className="inner-hero">
                                <h2 className="data-title">
                                    <span className="data-name">
                                        {translations?.plan}
                                    </span>
                                    <span className={classnames(
                                        {
                                            'data-type': true,
                                            'trainer': plan?.name === tempStyleDependency.trainer,
                                            'high-priest': plan?.name === tempStyleDependency.highPriest,
                                            'sage': plan?.name === tempStyleDependency.sage,
                                        }
                                    )}
                                    >
                                        {plan?.name}
                                    </span>
                                </h2>
                                {/*<span className="data-description">*/}
                                {/*    {plan?.description}*/}
                                {/*    {' '}*/}
                                {/*    {plan?.price === 0 && (*/}
                                {/*        <span className="data-price">*/}
                                {/*            {translations?.free}*/}
                                {/*        </span>*/}
                                {/*    )}*/}
                                {/*</span>*/}
                                <div className="inner-price">
                                    <span className="data-price">
                                        {plan?.priceDisplay}
                                    </span>
                                    <span className="data-price-description">
                                        {translations?.price}
                                    </span>
                                </div>
                            </div>
                            <div className="inner-content">
                                <h3 className="data-content-title">
                                    {translations?.listDetails}
                                </h3>
                                <ul className="list">
                                    {plan?.options?.map((option, index) => (
                                        <li
                                            key={`${option?.label}-${option?.value}-${index}`}
                                            className={classnames(['list-element', { active: !!option?.value }])}
                                        >
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="icon"
                                                width={18}
                                            />
                                            <span className="data-label">
                                                {option?.label}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="controls-block">
                                <Button
                                    className="gradient-180"
                                    style={ButtonStyles.Primary}
                                    variant={ButtonVariants.Primary}
                                    onClick={() => {
                                        // if (isLogged) {
                                        //     const { publicRuntimeConfig } = getConfig();
                                        //     return window.location.href = `${publicRuntimeConfig.APP_PARTNER_URL}/admin/packages`;
                                        // }

                                        router.push({
                                            pathname: Routes.PublicPartnerLogin,
                                            query: {
                                                forwardRedirect: 'packages',
                                            },
                                        });
                                    }}
                                >
                                    {translations?.active}
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default SectionPlans;
